import parse from "html-react-parser";
import IconComponent from "../IconComponent";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import moment from "moment";
import { FontAwesomeIcon } from "../../../../../CommonComponents/AssetsHelper";

const PlanDetailCard = ({ planDetail }) => {
  return (planDetail.divHide === 0 ? planDetail.title != 'Screen Limit' ?  <div className="col-xl-2-5 col-md-4 col-sm-6 mb-3">
    <div className="card card-custom card-stretch overflow-hidden account_status_card">
      {planDetail.trueIcon ? (
        planDetail.status ? (
          <div className="card_status status_checked">
            
            <IconComponent class_name={"symbol-24 f-center"}>
              <FontAwesomeIcon type={'regular'} icon={'check'} iconClass={'text-white'} />
            </IconComponent>
          </div>
        ) : (
          <div className="card_status status_unchecked">
            <IconComponent class_name={"symbol-24 f-center"}>
              <FontAwesomeIcon type={'regular'} icon={'xmark'} iconClass={'text-white'} />
            </IconComponent>
          </div>
        )
      ) : null}

      <div className="card-body text-center p-4">
        <span className="plan_icon svg-icon-3x">
          {parse(planDetail.icon)}
        </span>
        <h5 className="card-title font-weight-bold mt-3 mb-2 d-block h6">
          {planDetail.title}{" "}{ planDetail.title.includes('Twitter') && Number(planDetail.limitResetDate)!==0 && <OverlayTrigger
            placement='top'
            overlay={
              <Tooltip>{`limit reset date ${moment.unix(Number(planDetail.limitResetDate)).format("Do MMM, YYYY")}`}</Tooltip>
            }
          >
            <i className="fa fa-info-circle"></i>
          </OverlayTrigger>}
        </h5>
        {planDetail.total ? (
          <span className="font-weight-bold text-muted  font-size-sm d-block" style={{ minHeight: 20 }}>
            using <span className="text-dark">{planDetail.using}</span> out of{" "}
            <span className="text-dark">{planDetail.total}</span>
          </span>
        ) : null}

        <span className="font-weight-bold text-muted  font-size-sm d-block" style={{ minHeight: 20 }}>
          {planDetail.viewMonth ||
            (planDetail.title === "UGC Request/Month" && planDetail.status)}
        </span>
      </div>
    </div>
  </div> : null : null
  );
};

export default PlanDetailCard;
